import { useHandler } from 'src/hooks'

/**
 * Enhance props with automatic parsing of native inputs onChange events
 *
 * @param {Object} props
 * @return {Object} enhanced props
 */
export default function useNativeInput({ onChange, readOnly }) {
  return {
    onChange: useHandler(event => onChange && !readOnly && onChange(event.target.value)),
  }
}
